module.exports = __webpack_public_path__ + "img/timg.85200b4f.gif";